import React, { useState, useEffect } from "react"

import Icon from "icons"
import Loader from "components/common/loader"
import useSessionStorage from "hooks/useSessionStorage"
import { useLocation } from "store/contexts/location"
import useRecaptcha from "../../login/hooks/useRecaptcha"
import { Title, Text, ErrorText } from "../styles"
import { GoogleButton, Line, OrLabel, Input, SubmitButton, FormEl } from "./styles"

const Form = ({ switchScreen, redirectTo }) => {
  const [, setSignInEmail] = useSessionStorage("signInEmail", "")
  const { verifyRecaptcha } = useRecaptcha()

  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const [googleLoginHash, setGoogleLoginHash] = useState("")
  const { location } = useLocation()

  useEffect(() => {
    setGoogleLoginHash(window ? window.crypto.randomUUID() : "")
  }, [])

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (loading) return

    setLoading(true)
    setError("")

    // get email value
    const formData = new FormData(event.target)
    const email = formData.get("email")

    if (!email) {
      setError("Email is required.")
      return
    }
    // store email in session storage
    setSignInEmail(email)

    try {
      await verifyRecaptcha()
    } catch (err) {
      setError(`Recaptha error: ${err?.message}`)
      setLoading(false)
      return
    }

    const response = await fetch("/api/account/login-passwordless", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ email }),
    })

    if (!response.ok) {
      setLoading(false)
      const errorData = await response.json()
      setError(
        errorData.message ||
          "Something went wrong. We could not send you the email. Please try to sign in again.",
      )
      return
    }

    // const responseData = await response.json()
    setLoading(false)
    switchScreen()
  }

  const handleGoogleButtonClick = () => {
    window.localStorage.setItem("redirectTo", redirectTo || "/")
  }

  return (
    <>
      <Title>Welcome to mindbodygreen</Title>
      <Text>
        Manage your subscriptions, access your classes, view saved articles and receive exclusive
        discounts
      </Text>

      <a
        // eslint-disable-next-line max-len
        href={`https://${process.env.GATSBY_AUTH0_API_DOMAIN}/authorize?response_type=code&client_id=${process.env.GATSBY_AUTH0_APP_CLIENT_ID}&scope=openid%20profile%20email&connection=google-oauth2&redirect_uri=${location.origin}/account/callback/login&state=${googleLoginHash}`}
        onClick={handleGoogleButtonClick}
      >
        <GoogleButton aria-label="Continue with Google" tabIndex={-1}>
          <Icon id="google-icon" width={18} height={17} />
          Continue with Google
        </GoogleButton>
      </a>

      <Line>
        <OrLabel>OR</OrLabel>
      </Line>

      <ErrorText>{error}</ErrorText>

      <FormEl onSubmit={handleSubmit}>
        <Input type="email" placeholder="Email" name="email" aria-label="Email address" required />
        <SubmitButton type="submit" disabled={loading}>
          {loading ? <Loader /> : "CONTINUE"}
        </SubmitButton>
      </FormEl>
    </>
  )
}

export default Form
